/*******************************************************
	Funimation :: Theater Locator
*******************************************************/
(function ($)
{
	'use script';

	var theater_data = null;

	function rad2deg(angle) {
		return angle * 57.29577951308232; // angle / Math.PI * 180
	}

	function deg2rad(rad) {
			return rad * 0.017453292519943295;
	}

	// Sets the map on all markers in the array.
	function setMapOnAll(map) {
		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(map);
		}
	}

	// Removes the markers from the map, but keeps them in the array.
	function clear_markers() {
		setMapOnAll(null);
	}

	// Shows any markers currently in the array.
	function show_markers() {
		setMapOnAll(map);
	}

	// Deletes all markers in the array by removing references to them.
	function delete_markers() {
		clear_markers();
		markers = [];
	}
	
	// Ajax theater movie data from API.
	function ajax_movie_data() {
		var ajaxCall = $.getJSON(theater_locator_api, function(results, status) {
			if(status == "success") {
				theater_data = results;
			}
		});

		return ajaxCall;
	}

	if(jQuery('#theater_locator.list').length) {
		ajax_movie_data().done(function() {
	
			var states = [
				{
					"name": "Alabama",
					"abbreviation": "AL"
				},
				{
					"name": "Alaska",
					"abbreviation": "AK"
				},
				{
					"name": "American Samoa",
					"abbreviation": "AS"
				},
				{
					"name": "Arizona",
					"abbreviation": "AZ"
				},
				{
					"name": "Arkansas",
					"abbreviation": "AR"
				},
				{
					"name": "California",
					"abbreviation": "CA"
				},
				{
					"name": "Colorado",
					"abbreviation": "CO"
				},
				{
					"name": "Connecticut",
					"abbreviation": "CT"
				},
				{
					"name": "Delaware",
					"abbreviation": "DE"
				},
				{
					"name": "District Of Columbia",
					"abbreviation": "DC"
				},
				{
					"name": "Federated States Of Micronesia",
					"abbreviation": "FM"
				},
				{
					"name": "Florida",
					"abbreviation": "FL"
				},
				{
					"name": "Georgia",
					"abbreviation": "GA"
				},
				{
					"name": "Guam",
					"abbreviation": "GU"
				},
				{
					"name": "Hawaii",
					"abbreviation": "HI"
				},
				{
					"name": "Idaho",
					"abbreviation": "ID"
				},
				{
					"name": "Illinois",
					"abbreviation": "IL"
				},
				{
					"name": "Indiana",
					"abbreviation": "IN"
				},
				{
					"name": "Iowa",
					"abbreviation": "IA"
				},
				{
					"name": "Kansas",
					"abbreviation": "KS"
				},
				{
					"name": "Kentucky",
					"abbreviation": "KY"
				},
				{
					"name": "Louisiana",
					"abbreviation": "LA"
				},
				{
					"name": "Maine",
					"abbreviation": "ME"
				},
				{
					"name": "Marshall Islands",
					"abbreviation": "MH"
				},
				{
					"name": "Maryland",
					"abbreviation": "MD"
				},
				{
					"name": "Massachusetts",
					"abbreviation": "MA"
				},
				{
					"name": "Michigan",
					"abbreviation": "MI"
				},
				{
					"name": "Minnesota",
					"abbreviation": "MN"
				},
				{
					"name": "Mississippi",
					"abbreviation": "MS"
				},
				{
					"name": "Missouri",
					"abbreviation": "MO"
				},
				{
					"name": "Montana",
					"abbreviation": "MT"
				},
				{
					"name": "Nebraska",
					"abbreviation": "NE"
				},
				{
					"name": "Nevada",
					"abbreviation": "NV"
				},
				{
					"name": "New Hampshire",
					"abbreviation": "NH"
				},
				{
					"name": "New Jersey",
					"abbreviation": "NJ"
				},
				{
					"name": "New Mexico",
					"abbreviation": "NM"
				},
				{
					"name": "New York",
					"abbreviation": "NY"
				},
				{
					"name": "North Carolina",
					"abbreviation": "NC"
				},
				{
					"name": "North Dakota",
					"abbreviation": "ND"
				},
				{
					"name": "Northern Mariana Islands",
					"abbreviation": "MP"
				},
				{
					"name": "Ohio",
					"abbreviation": "OH"
				},
				{
					"name": "Oklahoma",
					"abbreviation": "OK"
				},
				{
					"name": "Oregon",
					"abbreviation": "OR"
				},
				{
					"name": "Palau",
					"abbreviation": "PW"
				},
				{
					"name": "Pennsylvania",
					"abbreviation": "PA"
				},
				{
					"name": "Puerto Rico",
					"abbreviation": "PR"
				},
				{
					"name": "Rhode Island",
					"abbreviation": "RI"
				},
				{
					"name": "South Carolina",
					"abbreviation": "SC"
				},
				{
					"name": "South Dakota",
					"abbreviation": "SD"
				},
				{
					"name": "Tennessee",
					"abbreviation": "TN"
				},
				{
					"name": "Texas",
					"abbreviation": "TX"
				},
				{
					"name": "Utah",
					"abbreviation": "UT"
				},
				{
					"name": "Vermont",
					"abbreviation": "VT"
				},
				{
					"name": "Virgin Islands",
					"abbreviation": "VI"
				},
				{
					"name": "Virginia",
					"abbreviation": "VA"
				},
				{
					"name": "Washington",
					"abbreviation": "WA"
				},
				{
					"name": "West Virginia",
					"abbreviation": "WV"
				},
				{
					"name": "Wisconsin",
					"abbreviation": "WI"
				},
				{
					"name": "Wyoming",
					"abbreviation": "WY"
				},
				{
					"name": "Alberta",
					"abbreviation": "AB"
				},
				{
					"name": "British Columbia",
					"abbreviation": "BC"
				},
				{
					"name": "Manitoba",
					"abbreviation": "MB"
				},
				{
					"name": "New Brunswick",
					"abbreviation": "NB"
				},
				{
					"name": "Newfoundland and Labrador",
					"abbreviation": "NL"
				},
				{
					"name": "Northwest Territories",
					"abbreviation": "NT"
				},
				{
					"name": "Nova Scotia",
					"abbreviation": "NS"
				},
				{
					"name": "Nunavut",
					"abbreviation": "NU"
				},
				{
					"name": "Ontario",
					"abbreviation": "ON"
				},
				{
					"name": "Prince Edward Island",
					"abbreviation": "PE"
				},
				{
					"name": "Quebec",
					"abbreviation": "QC"
				},
				{
					"name": "Saskatchewan",
					"abbreviation": "SK"
				},
				{
					"name": "Yukon",
					"abbreviation": "YT"
				}
			];
			var countries = [
				{ abbreviation: "US", name: "United States" },
				{ abbreviation: "CA", name: "Canada" }
			];
			var theaters = theater_data;

			var lookup = {};
			var result = [];

			// console.log(theaters[0]);

			if(theaters.length) {
				jQuery('#loading').remove();
				jQuery('.filter_controls').add('.states-wrapper').removeClass('hidden');
			}

			for (var theater, i = 0; theater = theaters[i++];) {				
				var country = theater.theater_country;

				if (!(country in lookup)) {
					lookup[country] = 1;
					result.unshift(country);
				}
			}

			if(result.length > 1) {
				for( var c = 0; c < result.length; c++) {
					var filteredCountry = countries.find(function(el) {
						return result[c] == el.abbreviation;
					});
					jQuery('#countries').append('<option value="'+filteredCountry.abbreviation+'">'+filteredCountry.name+'</option>');
				}

				jQuery('#countries').on('change', function() {
					var country = jQuery(this).val();
					if(country == "US") {
						jQuery('select[data-country=US]').val('').parents('.form-group').removeClass('hidden');
						jQuery('select[data-country=CA]').val('').parents('.form-group').addClass('hidden');
					} else {
						jQuery('select[data-country=US]').val('').parents('.form-group').addClass('hidden');
						jQuery('select[data-country=CA]').val('').parents('.form-group').removeClass('hidden');
					}				
				});
			} else {
				jQuery('.countries-wrapper').addClass('hidden');
			}

			jQuery('.form-group select:not(#countries)').on('change', function() {
				var stateProvidence = jQuery(this).val();
				if(stateProvidence) {
					jQuery('html, body').animate({
						scrollTop: jQuery('h3[data-abbreviation='+stateProvidence+']').offset().top - jQuery('#main-navigation').outerHeight()
					}, 1000);
				}
			});

			(function($) {
				var theaterList = "";
				var movieCountries = [];

				$.each(result, function(i) {
					var theatersByCountry = theaters.filter(function(el) {
						return el.theater_country == result[i];
					});
					movieCountries.push({ country: result[i], theaters: theatersByCountry });
				});

				$.each(movieCountries, function(i) {
					var movieTheaters = movieCountries[i].theaters;

					// Country Heading
					if(result.length > 1){
						var country = countries.filter(function(el) {
							return result[i] == el.abbreviation;
						});
						theaterList += '<div class="clearfix" style="padding-bottom:30px"></div>';
						theaterList += '<h2>' + country[0].name + '</h2>';
					}

					var stateLookup = {};
					var stateResults = [];
					$.each(states, function() {
						$.each(movieTheaters, function(k) {
							var state = movieTheaters[k].theater_state;

							if (!(state in stateLookup)) {
								stateLookup[state] = 1;
								stateResults.push(state);
							}
						});
					});

					$.each(stateResults, function(j) {
						var stateName = states.filter(function(el) {
							return stateResults[j] == el.abbreviation;
						});

						jQuery('select[data-country='+movieCountries[i].country+']').append('<option value='+stateName[0].abbreviation+'>'+stateName[0].name+'</option>');

						// THEATER STATE
						theaterList += '<h3 data-abbreviation="'+stateName[0].abbreviation+'">' + stateName[0].name + '</h3>';
						theaterList += '<div class="table_header col-xs-12">';
						theaterList += '<div class="col-xs-3">City</div>';
						theaterList += '<div class="col-xs-4">Theater</div>';
						theaterList += '<div class="col-xs-3">Dates</div>';
						theaterList += '<div class="col-xs-2">Tickets</div>';
						theaterList += '</div>';
						movieTheaters.filter(function(el) {
							if(el.theater_state == stateResults[j]) {
								var buttons = "";
								for(var b = 0; b < el.theater_urls.length; b++) {
									buttons += '<a class="buy_ticket_btn" href="' +  el.theater_urls[b].theater_url + '" target="_blank">' + el.theater_urls[b].theater_button_text + '</a>';
								}

								// TEATHER ROW
								theaterList += '<div class="table_content col-xs-12">';
								theaterList += '<div class="col-xs-3">' + el.theater_city + '</div>';
								theaterList += '<div class="col-xs-4">' + el.theater_name + '</div>';
								theaterList += '<div class="col-xs-3">' + el.theater_start_date + ' - ' + el.theater_end_date + '</div>';
								theaterList += '<div class="col-xs-2">' + buttons + '</div>';
								theaterList += '</div>';
							}
						});
					});
				});
				$("#theater-list").append(theaterList);
			})(jQuery);
		});
	} else {
		var zip_code_search_geocode = null;		

		var map = null;
		var markers = [];
		var content = [];
		var info_window = [];
		var bounds = null;
		var input = null;
		var autocomplete;

		// pulled from the 'part_single.php' page
		if(typeof autocomplete_character_trigger !== 'undefined')
			var theaterLocatorAutoComplete_Init_Char_Count = autocomplete_character_trigger;

		// pulled from the 'part_single.php' page
		var search_radius = (typeof map_radius_distance_in_miles !== 'undefined') ? map_radius_distance_in_miles : 50; // 50 miles

		var google_api_init = false;
		var google_suggestion_used = false;

		// function to center map
		var center_map = function () {
			var center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.setCenter(center);
		}

		var map_search = function () {
			var geocoder = new google.maps.Geocoder();

			// centers map on map search
			setTimeout(function() {
				center_map();
			}, 250);

			geocoder.geocode({'address': jQuery('#theater_locator_zip_input input').val()}, function(results, status)
			{
				if (status == google.maps.GeocoderStatus.OK)
				{
					lat = results[0].geometry.location.lat();
					lng = results[0].geometry.location.lng();

					zip_code_search_geocode = new google.maps.LatLng(lat, lng);
					empty_theater_list = '<p class="noTheaterResults">Sorry, there are no theaters available in this area; please try another location.</p>';

					if(theater_data != null && theater_data != '') {
						build_markers(theater_data);
					} else {
						jQuery('#theater_locator_list').html(empty_theater_list);
						jQuery('#theater_locator_list_wrapper').addClass('active');
						jQuery('#theater_locator_map').addClass('active');
					}

					if(jQuery('#theater_locator_list').children().length > 0) {
						sort_result_list();
					} else {
						jQuery('#theater_locator_list').html(empty_theater_list);
					}
				}
			});
		}

		var init_map = function () {
			if(document.getElementById('theater_locator_map') && !google_api_init) {
				map = new google.maps.Map(document.getElementById('theater_locator_map'),
				{
					panControl: false,
					zoomControl: true,
					streetViewControl: false,
					zoom: 5,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					center: new google.maps.LatLng(33.03744944, -97.0969552),
					disableDefaultUI: true,
					scrollwheel: false,
					mapTypeControl: false,
					navigationControl: false,
					scaleControl: true,
				});

				input = document.getElementById('theater_locator_input');

				marker = [];
				content = [];
				info_window = [];

				// Get the theater locator list file for the specific movie
				var reader = new XMLHttpRequest();
				reader.open('GET', theater_locator_api, false);
				reader.onreadystatechange = function() {
					if(reader.readyState === 4) {
						if(reader.status === 200 || reader.status == 0) {
							theater_data = JSON.parse(reader.responseText);
						}
					}
				}

				reader.send(null);

				// center map on resize
				google.maps.event.addDomListener(window, "resize", function() {
					center_map();
				});

				google_api_init = true;
			}
		}

		// On click of the theater locator submit button init the map search
		jQuery('#theater_locator_zip_input input').keypress(function(e) {
			if (e.which == 13) {
				map_search();
			}
		});

		jQuery('#theater_locator_zip_input input').keyup(function() {
			if(jQuery(this).val().length >= theaterLocatorAutoComplete_Init_Char_Count) {
				if (autocomplete == undefined) {
					autocomplete = new google.maps.places.Autocomplete(input);
					setTimeout(function() {
						google.maps.event.trigger( input, 'focus', {} );
					},200);
				}
			}

			else if (autocomplete != undefined) {
				google.maps.event.clearInstanceListeners(input);
				autocomplete = undefined;
				jQuery('.pac-container').remove();
			}
		});

		jQuery('#theater_locator_zip_input input').bind('focusout', function() {
			jQuery('.theater_locator_input_enter').addClass('animate');
		});

		jQuery('#theater_locator_zip_input input').bind('focusin', function() {
			jQuery('.theater_locator_input_enter').removeClass('animate');
			init_map();
		});

		jQuery('#theater_locator_zip_input input').change(function() {
			setTimeout(function() {
				if(google_suggestion_used)
					map_search();

				google_suggestion_used = false;
			}, 250);
		});

		jQuery('.theater_locator_input_enter').bind('click', function() {
			map_search();
		});

		jQuery(document).on('mousedown', '.pac-container', function() {
			google_suggestion_used = true;
		});

		var build_markers = function(data) {
			// clears Theater Locator list and markers from the map
			clear_theaters();

			bounds = new google.maps.LatLngBounds();
			var search_result_item_index = 0;

			// Generate map markers
			jQuery.each(data, function(i, marker) {
				// current marker lat,long
				var check_marker_lat_long = new google.maps.LatLng(marker.theater_latitude, marker.theater_longitude);

				if(zip_code_search_geocode !== null && check_marker_lat_long !== null)
				{
					max_lat = zip_code_search_geocode.lat() + rad2deg(search_radius/geo_code_calc.earth_radius_in_miles);
					min_lat = zip_code_search_geocode.lat() - rad2deg(search_radius/geo_code_calc.earth_radius_in_miles);

					max_lng = zip_code_search_geocode.lng() + rad2deg(search_radius/geo_code_calc.earth_radius_in_miles/Math.cos(deg2rad(zip_code_search_geocode.lat())));
					min_lng = zip_code_search_geocode.lng() - rad2deg(search_radius/geo_code_calc.earth_radius_in_miles/Math.cos(deg2rad(zip_code_search_geocode.lat())));

					if((check_marker_lat_long.lat() >= min_lat && check_marker_lat_long.lat() <= max_lat)
						&& (check_marker_lat_long.lng() >= min_lng && check_marker_lat_long.lng() <= max_lng)) {
						var distance_from_center = geo_code_calc.CalcDistance(zip_code_search_geocode.lat(), zip_code_search_geocode.lng(), check_marker_lat_long.lat(), check_marker_lat_long.lng(), geo_code_calc.earth_radius_in_miles);

						var mile_text = distance_from_center > 1 ? "miles" : "mile";

						//********to format ticket regex*****************
						var ticket_regex_obj = marker.theater_urls;

						ticket_regex_btns = '';

						for(var u = 0; u < ticket_regex_obj.length; u++) {
							ticket_regex_btn_text = ticket_regex_obj[u].theater_button_text != '' ? ticket_regex_obj[u].theater_button_text : 'Buy Tickets';
							ticket_regex_btns += '<a class="btn inverse theater_location_exhibitor" target="blank" href="'+ticket_regex_obj[u].theater_url+'">'+ticket_regex_btn_text+'</a>';
						}

						// build locator list container
						var list_container = '<div class="theater_location_item" data-distance='+distance_from_center.toFixed(2)+'>'+
							'<div class="theater_location_name">'+marker.theater_name+'</div>'+
							'<div class="theater_location_address">'+marker.theater_address+'<br/>'+marker.theater_city+', '+marker.theater_state+' '+marker.theater_zip+'</div>'+
							'<div class="theater_location_distance">Distance: <span class="theater_location_distance_miles">'+distance_from_center.toFixed(2)+'</span> '+mile_text+'</div>';

						if(marker.theater_start_date.length)
							list_container += '<div class="theater_movie_date">Start Date: <strong>'+marker.theater_start_date+'</strong></div>';

						list_container += ticket_regex_btns;

						jQuery('#theater_locator_list').append(list_container);

						// create marker
						markeritem = null;
						markeritem = new google.maps.Marker({
							position: check_marker_lat_long,
							map: map,
							title: marker.theater_name,
							icon: '/wp-content/themes/FUNi_Theaters/images/icons/map-pin.png',
							resultIndex: search_result_item_index
						});

						markers.push(markeritem);

						bounds.extend(check_marker_lat_long);

						// marker content
						var content = '<div class="popup_container">' +
							'<h4>'+marker.theater_name+'</h4>' +
							'<p class="address">'+marker.theater_address+'<br/>'+marker.theater_city+', '+marker.theater_state+' '+marker.theater_zip+'</p>' +
							'<p class="distance">Distance: '+distance_from_center.toFixed(2)+' '+mile_text+'</p>';

						if(marker.theater_start_date.length)
							content += '<div class="screen_date">Start Date: <strong>'+marker.theater_start_date+'</strong></div>';

						content += ticket_regex_btns;
						content += '</div>';

						info_window = new google.maps.InfoWindow({
							content: content
						});

						// marker listener for opening/closing info windows
						google.maps.event.addListener(markeritem, 'click', function()
						{
							info_window.close();
							info_window.setContent(content);
							info_window.open(map, this);
							map.panTo(this.getPosition());

							jQuery('#theater_locator_list .theater_location_item').removeClass('active');
							jQuery('#theater_locator_list .theater_location_item[data-index="'+this.resultIndex+'"]').addClass('active');

							var scrollPos = jQuery('#theater_locator_list .theater_location_item[data-index="'+this.resultIndex+'"]').position().top;
							jQuery('#theater_locator_list_wrapper').animate({
								scrollTop: scrollPos
							}, 400);
						});

						search_result_item_index++;
					}
				}
			});

			// add theater locator list
			jQuery('#theater_locator_list_wrapper').addClass('active');
			jQuery('#theater_locator_map').addClass('active');

			show_markers();
			map.fitBounds(bounds);
		};

		var sort_result_list = function()
		{
			var items_container = jQuery('#theater_locator_list');
			var items = items_container.find('.theater_location_item');

			items.each(function(i) {
				jQuery(this).attr("data-index", i);
			});

			var was_swap = true;
			var sorted_items;

			while(was_swap) {
				was_swap = false;

				sorted_items = items.sort(function(a,b){
					return +a.dataset.distance - +b.dataset.distance;
				});
			}

			items_container.html('');
			items_container.append(sorted_items);

			jQuery("body").on('click', '#theater_locator_list .theater_location_item', function(){
				var markerIndex = jQuery(this).data('index');
				new google.maps.event.trigger( markers[markerIndex], 'click' );
			});
		};

		var clear_theaters = function() {
			// clear Theater Locator List
			jQuery('#theater_locator_list').html('');

			// clears and deletes markers from map
			delete_markers();
			clear_markers();
		};

		// Geo Code Calculation
		var geo_code_calc = {};

		geo_code_calc.earth_radius_in_miles = 3956.0;
		geo_code_calc.to_radian = function(v) { return v * (Math.PI / 180);};
		geo_code_calc.diff_radian = function(v1, v2) {
			return geo_code_calc.to_radian(v2) - geo_code_calc.to_radian(v1);
		};

		geo_code_calc.CalcDistance = function(lat1, lng1, lat2, lng2, radius) {
			return radius * 2 * Math.asin( Math.min(1, Math.sqrt( ( Math.pow(Math.sin((geo_code_calc.diff_radian(lat1, lat2)) / 2.0), 2.0) + Math.cos(geo_code_calc.to_radian(lat1)) * Math.cos(geo_code_calc.to_radian(lat2)) * Math.pow(Math.sin((geo_code_calc.diff_radian(lng1, lng2)) / 2.0), 2.0) ) ) ) );
		};
	}
})(jQuery);